import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAuthToken } from '../utils/auth';
import { TABLE_ICONS } from '../utils/tableIcons';
import { AUTH_CONFIG } from '../config/auth';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Simulate a small delay for better UX
      await new Promise(resolve => setTimeout(resolve, 500));

      if (email === AUTH_CONFIG.ADMIN_EMAIL && password === AUTH_CONFIG.ADMIN_PASSWORD) {
        // Set authentication token with 1-hour expiration
        setAuthToken(email);

        // Navigate to admin dashboard
        navigate('/admin/dashboard');
      } else {
        setError('Invalid email or password. Please try again.');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    if (error) setError(''); // Clear error when user starts typing
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Left Panel - Blue Background */}
        <div className="login-left-panel">
          <div className="left-panel-content">
            <div className="company-logo">
              <span className="company-name">YASHASHVI BHAVA</span>
            </div>

            <div className="welcome-section">
              <p className="welcome-subtitle">Nice to see you again</p>
              <h1 className="welcome-title">WELCOME BACK</h1>
              <div className="welcome-underline"></div>
              <p className="welcome-description">
                Welcome to Yashashvi Bhava Admin Panel - Your comprehensive platform for
                managing digital content, user accounts, and creative assets. Streamline
                your workflow with our intuitive dashboard designed for efficient content
                management and user engagement.
              </p>
            </div>
          </div>

          {/* Animated Background Elements */}
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
          <div className="bg-circle circle-4"></div>
          <div className="bg-wave wave-1"></div>
          <div className="bg-wave wave-2"></div>
        </div>

        {/* Right Panel - Login Form */}
        <div className="login-right-panel">
          <div className="login-form-container">
            <div className="right-panel-logo">
              <img src="/logo.png" alt="Yashashvi Bhav Logo" className="right-panel-logo-img" />
            </div>
            <div className="login-header">
              <h2>Admin Login</h2>
              <p>Hello, welcome back to Yashashvi Bhav Admin Panel</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={handleInputChange(setEmail)}
                  placeholder="Email ID"
                  required
                  className={error ? 'error' : ''}
                />
              </div>

              <div className="form-group">
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={handleInputChange(setPassword)}
                  placeholder="Password"
                  required
                  className={error ? 'error' : ''}
                />
              </div>


              {error && (
                <div className="error-message">
                  <span className="error-icon">{TABLE_ICONS.WARNING}</span>
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="login-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="loading-spinner"></div>
                    SIGNING IN...
                  </>
                ) : (
                  'LOGIN'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
